import React, { useContext } from "react";
import { SiteContext } from "./global/site-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import PortableText from "./portableText";
import { COMMUNITY_TAGS } from "../../helpers";

const CUTOFF_DATE = new Date("2024-01-01");

const DEFAULT_DISCLAIMER = [
  {
    _type: "block",
    children: [
      {
        _type: "span",
        text: "This content was created before our product launched and may reference features or capabilities that have since changed.",
      },
    ],
  },
];

export const ProductDisclaimer = ({ categories, _createdAt, publishedAt }) => {
  const site = useContext(SiteContext);

  // Check if document has any community category
  const hasCommunityCat = categories?.some((c) =>
    COMMUNITY_TAGS.includes(c._id)
  );

  // Check if date is before January 1st, 2024
  const beforeCutoff = new Date(publishedAt || _createdAt) < CUTOFF_DATE;

  // Only show if both conditions are met
  if (!hasCommunityCat || !beforeCutoff) return null;

  const disclaimerText =
    site?._rawProductDisclaimerText || DEFAULT_DISCLAIMER;

  return (
    <div
      className="rounded-lg my-6 p-4"
      style={{
        background: "rgba(236, 239, 253, 1)",
        boxShadow: "0px 0px 0px 1px rgba(63, 100, 239, 0.3)",
      }}
    >
      <div className="flex items-start">
        <FontAwesomeIcon
          icon={faCircleInfo}
          className="mr-3 mt-1 text-link shrink-0 h-6"
          size="lg"
        />
        <div>
          <h4 className="font-semibold text-primary mt-0.5 mb-2 text-lg">Product Update</h4>
          <div className="text-primary leading-relaxed">
            <PortableText blocks={disclaimerText} />
          </div>
        </div>
      </div>
    </div>
  );
};
